import React, { useState, useEffect } from 'react' 
import { useNavigate, Link } from 'react-router-dom';

import axios from "axios";
import * as Yup from "yup";
import swal from "sweetalert";

const options = [];
let cy = new Date().getFullYear();
for(let i=-2; i<10; i++){
    options.push({ value: cy+i, label: cy+i })
}

export default function DownloadExcel() {
    const [currYear, setCurrYear] = useState(cy);
    const [dis, setDis] = useState(false);
    const [btnText, setBtnText] = useState('Download');
    const handleChange = (e) => setCurrYear(e.target.value);
    const downloadExcel = (event, param) => {
        setDis(true);
        setBtnText('Please wait..');
        const postData = {year: currYear};
        axios.post(process.env.REACT_APP_API_KEY+"api/admin/exportdata", postData,
        {headers: {
          "Content-type": "Application/json",
          "Accept": "Application/json",
          "Authorization": `Bearer `+localStorage.getItem('token')
          }
        })
        .then((res) => {
            setDis(false);
            setBtnText('Download');
            var reData = res.data; 
            if(reData.status == true){
                reData = reData.data; 
                if(reData.erro == false) {
                  window.open(reData.url);
                }
            }
        });
    }

  return (
    <div className="wrapper">   
        <div className="content-wrapper">
            <form  className="mx-5 col-md-5 faq-form-admin">
                <h2>Download Excel</h2>
                <div className="ui form box-body">
                    <div className="field form-group">               
                        <label>Select Year</label>
                        <select className="form-control" name="year" onChange={handleChange}>
                            {options.map(({ value, label }, index) => <option value={value} >{label}</option>)}
                        </select>
                    </div>
                <div className="text-danger error-msg"></div>

                <div className='btn-allign'>
                    <Link to=""></Link>
                    <button type="button" className="btn btn-danger submit-btn" onClick={event => downloadExcel(event)} disabled={dis}>{btnText}</button>
                </div>
            </div>
        </form>
    </div>      
</div>
  )
}